import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';
export const BACKEND_URL = API_BASE_URL.replace(/\/api$/, '');

const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

// Toute réponse 401 (session expirée/absente) renvoie vers la page de
// connexion — sauf pour /auth/me et /auth/login qui gèrent leur propre 401.
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const url = error.config?.url || '';
    if (error.response?.status === 401 && !url.includes('/auth/me') && !url.includes('/auth/login')) {
      window.location.assign('/login');
    }
    return Promise.reject(error);
  }
);

// Auth
export const login = (email, password) => api.post('/auth/login', { email, password });
export const logout = () => api.post('/auth/logout');
export const getMe = () => api.get('/auth/me');
export const changePassword = (current_password, new_password) => api.post('/auth/change-password', { current_password, new_password });

// Admin (superadmin uniquement)
export const adminGetTenants = () => api.get('/admin/tenants');
export const adminCreateTenant = (data) => api.post('/admin/tenants', data);
export const adminSetTenantStatut = (id, statut) => api.put(`/admin/tenants/${id}/statut`, { statut });
export const adminResetTenantPassword = (id, password) => api.post(`/admin/tenants/${id}/reset-password`, { password });
export const adminGetAuditLogs = (params) => api.get('/admin/audit-logs', { params });
export const adminGetEReporting = (params) => api.get('/admin/e-reporting', { params });
export const adminUpdateEReporting = (factureId, data) => api.put(`/admin/e-reporting/${factureId}`, data);
export const adminGetContacts = () => api.get('/admin/contacts');

// Clients
export const getClients = () => api.get('/clients');
export const getClient = (id) => api.get(`/clients/${id}`);
export const createClient = (data) => api.post('/clients', data);
export const updateClient = (id, data) => api.put(`/clients/${id}`, data);
export const deleteClient = (id) => api.delete(`/clients/${id}`);

// Articles
export const getArticles = () => api.get('/articles');
export const getArticleById = (id) => api.get(`/articles/${id}`);
export const createArticle = (data) => api.post('/articles', data);
export const updateArticle = (id, data) => api.put(`/articles/${id}`, data);
export const deleteArticle = (id) => api.delete(`/articles/${id}`);

// Devis
export const getDevis = () => api.get('/devis');
export const getDevisById = (id) => api.get(`/devis/${id}`);
export const createDevis = (data) => api.post('/devis', data);
export const updateDevis = (id, data) => api.put(`/devis/${id}`, data);
export const deleteDevis = (id) => api.delete(`/devis/${id}`);
export const viewDevisPDF = (id) => {
  window.open(`${API_BASE_URL}/devis/${id}/pdf`, '_blank');
};
export const downloadDevisPDF = (id) => {
  window.open(`${API_BASE_URL}/devis/${id}/pdf?download=true`, '_blank');
};
export const envoyerDevisEmail = (id, email, message) => api.post(`/devis/${id}/envoyer-email`, { email, message });

// Factures
export const getFactures = () => api.get('/factures');
export const getFactureById = (id) => api.get(`/factures/${id}`);
export const createFacture = (data) => api.post('/factures', data);
export const updateFacture = (id, data) => api.put(`/factures/${id}`, data);
export const deleteFacture = (id) => api.delete(`/factures/${id}`);
export const emettreFacture = (id) => api.post(`/factures/${id}/emettre`);
export const createAvoir = (id) => api.post(`/factures/${id}/avoir`);
export const dupliquerFacture = (id) => api.post(`/factures/${id}/dupliquer`);
export const refreshRetards   = ()    => api.post('/factures/refresh-retards');
export const viewFacturePDF = (id) => {
  window.open(`${API_BASE_URL}/factures/${id}/pdf`, '_blank');
};
export const downloadFacturePDF = (id) => {
  window.open(`${API_BASE_URL}/factures/${id}/pdf?download=true`, '_blank');
};
// PDF simple : sans XML Factur-X embarqué
export const downloadFacturePDFSimple = (id) => {
  window.open(`${API_BASE_URL}/factures/${id}/pdf?download=true&facturx=false`, '_blank');
};
export const downloadFacturX = (id, numero) => {
  window.open(`${API_BASE_URL}/factures/${id}/facturx`, '_blank');
};

// Email factures
export const envoyerFactureEmail = (id, email, message) => api.post(`/factures/${id}/envoyer-email`, { email, message });
export const envoyerRappelEmail = (id, email, message) => api.post(`/factures/${id}/envoyer-rappel`, { email, message });

// Dashboard
export const getDashboard = () => api.get('/dashboard');

// Paiements (encaissements sur factures)
export const getPaiements = (factureId) => api.get(`/factures/${factureId}/paiements`);
export const addPaiement = (factureId, data) => api.post(`/factures/${factureId}/paiements`, data);
export const deletePaiement = (id) => api.delete(`/paiements/${id}`);

// Dépenses & notes de frais
export const getDepenses = (params) => api.get('/depenses', { params });
export const getDepense = (id) => api.get(`/depenses/${id}`);
export const createDepense = (data) => api.post('/depenses', data);
export const updateDepense = (id, data) => api.put(`/depenses/${id}`, data);
export const deleteDepense = (id) => api.delete(`/depenses/${id}`);

// Trésorerie
export const getTresorerieResume = (params) => api.get('/tresorerie/resume', { params });

// Référentiels
export const getPays = () => api.get('/pays');

// Entreprise
export const getEntreprise = () => api.get('/entreprise');
export const updateEntreprise = (data) => api.post('/entreprise', data);
export const uploadLogo = (file) => {
  const formData = new FormData();
  formData.append('logo', file);
  return api.post('/entreprise/logo', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export default api;

